import { useState, useEffect } from 'react'

export function useResetTimer() {
  const [timeUntilReset, setTimeUntilReset] = useState({ hours: 0, minutes: 0 })

  useEffect(() => {
    const calculateTimeUntilReset = () => {
      const now = new Date()

      // Calculate next UTC midnight
      const nextUtcMidnight = new Date(now)
      nextUtcMidnight.setUTCDate(nextUtcMidnight.getUTCDate() + 1)
      nextUtcMidnight.setUTCHours(0, 0, 0, 0)

      const diff = nextUtcMidnight.getTime() - now.getTime()
      const hours = Math.floor(diff / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

      setTimeUntilReset({ hours, minutes })
    }

    // Calculate immediately
    calculateTimeUntilReset()

    // Update every minute
    const interval = setInterval(calculateTimeUntilReset, 60000)

    return () => clearInterval(interval)
  }, [])

  return timeUntilReset
}
